

export const chartConfiguration = {
    donutChart: {
        chart: {
            type: "donut",
        },
        labels: ["Active", "Non-active"],
        colors: ["#3B9CB9", "#CDCDDF"],
        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                        },
                    },
                },
            },
        },
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            markers: {
                radius: 1,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val: any) => `${val.toFixed(1)}%`,
        },
    },
    donutChartTreatment: {
        chart: {
            type: "donut",
        },
        labels: ["Completed treatment", "Undergoing treatment"],
        colors: ["#3B9CB9", "#CDCDDF"],
        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                        },
                    },
                },
            },
        },
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            markers: {
                radius: 1,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val: any) => `${val.toFixed(1)}%`,
        },
    },
    // TODO: fix the chart size [maybe move the 'legend' at the button]
    coloredDonutChart: {
        chart: {
            type: "donut",
        },
        labels: ["OVER CURRENT ERROR", "HV OVER ERROR", "HV UNDER ERROR", "RIGHT BRIDGE ERROR", "CHECKSUM ERROR"],
        colors: ["#3B9CB9", "#CDCDDF", "#007D99", "#005F7A", "#00273F"],
        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    labels: {
                        show: false,
                        total: {
                            show: true,
                        },
                    },
                },
            },
        },
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            markers: {
                radius: 1,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val: any) => `${val.toFixed(1)}%`,
        },
    },
    lineChart: {
        chart: {
            type: "line",
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: true,
            },
        },
        dataLabels: {
            enabled: true,
        },
        stroke: {
            curve: "straight",
        },
        grid: {
            padding: {
                left: 10,
                right: 10,
            },
            row: {
                enabled: false,
            },
            column: {
                colors: ["#f3f3f3", "transparent"], // alternating row colors
                opacity: 0.5,
            },
        },
        xaxis: {
            categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        },
        yaxis: {
            min: 0, 
            labels: {
                formatter: (value: number) => {
                    return value.toFixed(0);
            },
        }
        },
    },
    barChart: {
        chart: {
            type: "bar",
            toolbar: { show: false },
            height: "100px",
            width: "50%",
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "20%",
                borderRadius: 4,
            },
        },
        dataLabels: {
            enabled: false, // Disable values displayed on top of the bars
        },
        xaxis: {
            show: false,
            categories: [
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
                "Center Name",
            ],
            labels: {
                style: {
                    colors: "#333",
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            show: false,
        },
    }
}